// extracted by mini-css-extract-plugin
module.exports = {"container":"FAQ_container__sCUGr","wrapper":"FAQ_wrapper__TYM8K","heading":"FAQ_heading__3_-MM","FQAs":"FAQ_FQAs__10snz"};